module.exports = __webpack_public_path__ + "img/FR13149.f06dc3e2.png";